import { numberToPrettyString } from '@cian/utils';

import { getCurrencySign } from './getCurrencySign';
import { IOfferCard } from '../../../types/card';

export function getAgentBonusPrice(offerCard: IOfferCard, isAgent: boolean): string | undefined {
  const { agentBonus } = offerCard.bargainTerms;
  const isSale = offerCard.dealType === 'sale';

  if (isAgent && agentBonus && isSale) {
    let bonus = numberToPrettyString(agentBonus.value);

    if (agentBonus.paymentType === 'percent') {
      bonus += '%';

      return `Бонус агенту ${bonus}`;
    }

    if (agentBonus.currency === 'rur') {
      bonus += `\u00A0${getCurrencySign(agentBonus.currency)}`;
    } else {
      bonus = `${getCurrencySign(agentBonus.currency || '')}${bonus}`;
    }

    return `Бонус агенту ${bonus}`;
  }

  return undefined;
}
